import { Box, Stack } from '@mui/material';
import { Typography } from '@chr/eds-react';
import { useTranslation } from '@chr/online-shared-ui-localizations';

import { ShipmentStop } from '@/common/apis/dtos';
import { RouteBreadcrumb } from '@/common/components/route-breadcrumb/routeBreadcrumb';
import { Section } from '@/common/components/section/Section';

import { StopProgress } from "./StopProgress";

export interface BookingProgressProps {
  stops: ShipmentStop[];
  pickupReadyByDate?: string;
}

export const BookingProgress = ({ stops, pickupReadyByDate }: BookingProgressProps) => {
  const translate = useTranslation();

  if (stops.length === 0) {
    return null;
  }

  return (
    <Section
      data-testid="booking-progress"
      headerParentSx={{
        paddingTop: '7px',
        paddingBottom: '7px',
      }}
      header={
        <Stack
          data-testid="eta-source-container"
          rowGap={2}
          direction={{ xs: 'column', sm: 'row' }}
          paddingBottom={{ xs: 1, sm: 0 }}
          display="flex"
          alignItems="center"
          justifyContent={'space-between'}
        >
          <Typography variant="heading300">{translate('Booking Progress')}</Typography>
        </Stack>
      }
    >
      <Stack
        direction="column"
        sx={{
          overflow: 'hidden',
          '& .crumb:not(:last-child) .stop-info': {
            borderBottom: (theme) => `1px solid ${theme.palette.grey[200]}`,
          },
          '& .crumb .stop-info': {
            flexGrow: 1,
          },
        }}
      >
        {stops.map((stop, index) => (
          <Box
            key={`stop-wrapper-${stop.stopNumber || index}`}
            className="crumb"
            display='flex'
            data-testid="booking-progress-row"
          >
            <RouteBreadcrumb stop={stop} nextStop={stops[index + 1]} />
            <StopProgress stop={stop} pickupReadyByDate={pickupReadyByDate} />
          </Box>
        ))}
      </Stack>
    </Section>
  );
}
